export default function isMiniStrProductUtil (str) {
  return /\bmini\b/i.test(str || '')
}
